module.exports = __webpack_public_path__ + "static/media/image-thumb-5.150d0b68.jpeg";